import { render, staticRenderFns } from "./UserTaskEditor.vue?vue&type=template&id=d0f36818"
import script from "./UserTaskEditor.vue?vue&type=script&lang=js"
export * from "./UserTaskEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports